import React from 'react';
import { Icon } from 'LocalGluons';

interface CheckboxProps {
    isChecked: boolean;
}

const Checkbox = ({ isChecked }: CheckboxProps): JSX.Element => (
    <div
        style={{
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#ededed',
            width: 24,
            height: 24,
            borderStyle: 'solid',
            marginRight: 12,
            borderWidth: 1,
            borderColor: '#b2b2b2',
            borderRadius: 3
        }}
    >
        {isChecked && <Icon name="confirm" style={{ width: 24, height: 24 }} />}
    </div>
);

export default Checkbox;
